import { useState, useEffect } from "react";
import debounce from "lodash.debounce";
import { breakpointDesktop } from "@airhelp/design-tokens";
const RESIZE_DEBOUNCE_TIME = 200;
export const getWindowWidth = () => {
    if (typeof window !== "undefined") {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return 0;
};
export function useMobileDetect() {
    const desktopWidth = parseInt(breakpointDesktop, 10);
    const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth < desktopWidth : false);
    const handleSizeChange = () => debounce(() => {
        const width = getWindowWidth();
        setIsMobile(width < desktopWidth);
    }, RESIZE_DEBOUNCE_TIME)();
    useEffect(() => {
        if (typeof window !== "undefined") {
            handleSizeChange();
            window.addEventListener("resize", handleSizeChange);
            return () => {
                window.removeEventListener("resize", handleSizeChange);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- we don't want to recompute on handleSizeChange
    }, [isMobile]);
    return isMobile;
}
